import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import AdminUsers from './pages/AdminUsers';
import Verification from './pages/Verification';
import Confirmation from './pages/confirmation';
import UserInfo from './pages/UserInfo';
import Layout from './Layout';
import GenerateQR from './pages/GenerateQR';
import FastSignUp from './pages/FastSignUp';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/signup',
    element: <SignUp />,
  },
  {
    path: '/fast-signup/signup',
    element: <FastSignUp />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: '/admin/users',
        element: <AdminUsers />,
      },
      {
        path: '/profile',
        element: <UserInfo />,
      },
      {
        path: '/fast-signup/generate-qr',
        element: <GenerateQR />,
      },
    ],
  },
  {
    path: '/verification',
    element: <Verification />,
  },
  {
    path: '/confirmation',
    element: <Confirmation />,
  },
]);

function Router() {
  return <RouterProvider router={router} />;
}

export default Router;